import React from 'react';
import { Badge, Card, Tabs } from 'antd';
import { PublicSurveyList } from './PublicSurveyList';
import { PublicSurveyPageData } from '../../types/publicSurvey.types';

const BRAND_GREEN = '#00984A';

interface PublicSurveyTabsProps {
  activeData?: PublicSurveyPageData;
  completedData?: PublicSurveyPageData;
  activeLoading: boolean;
  completedLoading: boolean;
  activePage: number;
  completedPage: number;
  onActivePage: (page: number) => void;
  onCompletedPage: (page: number) => void;
  onParticipate: (surveyId: string) => void;
}

export const PublicSurveyTabs: React.FC<PublicSurveyTabsProps> = ({
  activeData,
  completedData,
  activeLoading,
  completedLoading,
  activePage,
  completedPage,
  onActivePage,
  onCompletedPage,
  onParticipate,
}) => {
  const activeCount = activeData?.totalItems;

  const activeTabLabel = (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      Pesquisas Ativas
      {activeCount !== undefined && activeCount > 0 && (
        <Badge
          count={activeCount}
          overflowCount={99}
          style={{ backgroundColor: BRAND_GREEN, boxShadow: 'none' }}
        />
      )}
    </span>
  );

  return (
    <Card
      style={{ borderRadius: 8, boxShadow: '0 1px 2px 0 rgba(0,0,0,0.03), 0 1px 6px -1px rgba(0,0,0,0.02), 0 2px 4px 0 rgba(0,0,0,0.02)' }}
      styles={{ body: { padding: '0 24px 28px' } }}
    >
      <Tabs
        defaultActiveKey="active"
        size="large"
        items={[
          {
            key: 'active',
            label: activeTabLabel,
            children: (
              <PublicSurveyList
                title="Pesquisas Ativas"
                showTitle={false}
                data={activeData}
                loading={activeLoading}
                page={activePage}
                onPageChange={onActivePage}
                onParticipate={onParticipate}
              />
            ),
          },
          {
            key: 'completed',
            label: 'Finalizadas',
            children: (
              <PublicSurveyList
                title="Pesquisas Completas"
                showTitle={false}
                data={completedData}
                loading={completedLoading}
                page={completedPage}
                onPageChange={onCompletedPage}
              />
            ),
          },
        ]}
      />
    </Card>
  );
};
